import {useDispatch, useSelector} from "react-redux";
import React, {useEffect, useState} from "react";
import getMyData, {
    getECCategoryOptions, getECTypeOptions, getICCategoryOptions, getICTypeOptions,
    getVatExpenseClassificationType
} from "../../../_helpers/sharedmydata";
import axios from "axios";
import {toast} from "react-toastify";
import {setEditBuys, setNewBuys} from "../../../_reducers/DataPanel/Buys/buysSlice";
import {Button, Modal} from "react-bootstrap";
import Dropdown from "../Dropdown";
import Alert from "react-bootstrap/Alert";
import {vatCategoryData} from "../../../_data/mydata/vatCategory";
import BetterCheckBox from "../../common/BetterCheckBox";
import {getGreekCurrencyFormat, isEmpty} from "../../../_helpers/commonFunctions";
import FixedAssetBuysAction from "../../layouts/data-panel/FixedAssets/components/fixed-asset-buys-action";
import AccountingBox from "../AccountingBox";

const BuysProductQuickEdit = (props) => {
    const dispatch = useDispatch();
    const [show, setShow] = useState(false);
    const newBuy = useSelector((state) => state.BUYS.newBuys);
    const editBuy = useSelector((state) => state.BUYS.editBuys);
    const TABS_DATA = useSelector((state) => state.TABS_REDUCER);
    const ACTIVE_MAIN_TAB = useSelector((state) => state.ACTIVE_MAIN_TAB);
    const zeroVatReasonOptions = getMyData({ type: 'zerovatreason' });

    const [productData, setProductData] = useState(props.data);
    const [myData, setMyData] = useState([]);

    const isEditDisabled = editBuy.fromMyDataReport === "true" || !isEmpty(editBuy.mark);
    const isFromMyDataReport = editBuy.fromMyDataReport === "true";

    const ecCategory = isFromMyDataReport ?
        getECCategoryOptions().concat(getICCategoryOptions())
        :
        getECCategoryOptions().filter(el => myData.findIndex(md => md.category === el.value) !== -1);
    const ecType = isFromMyDataReport ?
        getECTypeOptions().concat(getICTypeOptions())
        :
        getECTypeOptions().filter(el => myData.findIndex(md => md.type === el.value && md.category === productData.classificationCategory) !== -1);
    const vatExpenseType = [{label: "Κενό", value: ""}].concat(getVatExpenseClassificationType());
    const primerMyDataData = useSelector((state) => state.SETTINGS.primerMyDataData);

    useEffect(() => {
        if(show === true) {
            axios.get(process.env.REACT_APP_API_URL2 + `/category/get-product-by-id/${productData._id}`)
                .then((res) => {
                    if(TABS_DATA[ACTIVE_MAIN_TAB].tabType === "buys-new") {
                        setMyData(res.data.data.mydata.filter((el) => String(el.invoiceType) === String(newBuy.myDataType) || String(el.invoiceType) === String(newBuy.classifiedDataType)));
                    } else if (TABS_DATA[ACTIVE_MAIN_TAB].tabType === "edit-buys") {
                        setMyData(res.data.data.mydata.filter((el) => String(el.invoiceType) === String(editBuy.myDataType) || String(el.invoiceType) === String(editBuy.classifiedDataType)));
                    }
                })
                .catch((err) => console.log(err));
        }
    }, [show])

    const getBuyObject = () => {
        if(TABS_DATA[ACTIVE_MAIN_TAB].tabType === "buys-new") {
            return newBuy;
        } else if (TABS_DATA[ACTIVE_MAIN_TAB].tabType === "edit-buys") {
            return editBuy;
        }
    }

    const saveClicked = () => {
        if (props.tableName === "Buys Products List" && TABS_DATA[ACTIVE_MAIN_TAB].tabType === "buys-new") {
            let allProducts = [...newBuy.products];
            allProducts.map((a) => Object.assign({}, a));
            let idx = allProducts.findIndex((el) => el.id === productData.id);
            if(idx === -1) {
                toast.error("Σφάλμα κατά την αποθήκευση, η γραμμή δεν υπάρχει.");
            } else {
                if(props.data.vatPercentage !== productData.vatPercentage) {
                    allProducts[idx] = {...allProducts[idx], ...productData, quantity: 1, unitPrice: 0, discount: 0, vat: 0, netValue: 0, totalValue: 0};
                } else {
                    allProducts[idx] = {...allProducts[idx], ...productData};
                }
                allProducts[idx].quickEdit = true;
                setShow(false);
                toast.success("Το είδος ενημερώθηκε.");
                dispatch(setNewBuys({...newBuy, products: allProducts}));
            }
        } else if (props.tableName === "Buys Products List" && TABS_DATA[ACTIVE_MAIN_TAB].tabType === "edit-buys") {
            dispatch(setEditBuys(true));
            let allProducts = [...editBuy.products];
            allProducts.map((a) => Object.assign({}, a));
            let idx = allProducts.findIndex((el) => el.id === productData.id);
            if(idx === -1) {
                toast.error("Σφάλμα κατά την αποθήκευση, η γραμμή δεν υπάρχει.");
            } else {
                if(props.data.vatPercentage !== productData.vatPercentage) {
                    allProducts[idx] = {...allProducts[idx], ...productData, quantity: 1, unitPrice: 0, discount: 0, vat: 0, netValue: 0, totalValue: 0};
                } else {
                    allProducts[idx] = {...allProducts[idx], ...productData};
                }
                allProducts[idx].quickEdit = true;
                setShow(false);
                toast.success("Το είδος ενημερώθηκε.");
                dispatch(setEditBuys({...editBuy, products: allProducts}));
            }
        }
    }
    const handleOnChange = (e, type, name) => {
        if (type === "dropdown") {
            if (name === "vatPercentage") {
                if (e.value === "8") {
                    setProductData({...productData, vatPercentage: "0", vatId: "8"});
                } else {
                    const findPercentage = vatCategoryData.find((el) => el.id === String(e.value))?.percentage;
                    if (findPercentage !== "0") {
                        setProductData({...productData, vatPercentage: findPercentage, vatId: e.value});
                    } else {
                        setProductData({...productData, vatPercentage: findPercentage, vatReason: "", vatId: e.value});
                    }
                }
            } else if (name === "vatReason") {
                setProductData({...productData, vatReason: e.value});
            } else if (name === "classificationCategory") {
                setProductData({...productData, classificationCategory: e.value, classificationType: ""});
            } else if (name === "classificationType") {
                setProductData({...productData, classificationType: e.value});
            } else if (name === "vatExpenseType") {
                setProductData({...productData, vatExpenseType: e.value});
            }
        } else if (type === "checkbox") {
            setProductData({...productData, accountingNonDeductibleVAT: e.target.checked === true ? "inactive" : "active"})
        } else if (type === "acb") {
            let val = +e.target.value;
            if (isNaN(val)) val = 0;
            setProductData({...productData, [name]: val, vat39aCategory: productData.vat39aCategory || "1"});
        }
    }
    const invalidProduct = () => {
        return isEmpty(productData.vatPercentage)
            || (String(productData.vatId) === "7" && isEmpty(productData.vatReason))
            || (isEmpty(productData.classificationCategory) && !isEmpty(getBuyObject()?.myDataType))
            || (isEmpty(productData.classificationType) && !isEmpty(getBuyObject()?.myDataType));
    }
    const getVatOptions = () => {
        let opt = [];
        for (let vatObj of vatCategoryData) {
            opt.push({label: vatObj.description, value: vatObj.id});
        }
        return opt;
    }

    const getTaxName = (id, type) => {
        if (type === "otherTax") return primerMyDataData?.otherTaxes?.find((el) => +el.id === +id)?.name || "";
        if (type === "fee") return primerMyDataData?.fees?.find((el) => +el.id === +id)?.name || "";
        if (type === "withHoldTax") return primerMyDataData?.withHoldTaxes?.find((el) => +el.id === +id)?.name || "";
        if (type === "stamp") return primerMyDataData?.stamp?.find((el) => +el.id === +id)?.name || "";
    }

    return (
        <React.Fragment>
            <Button style={{pointerEvents: "auto"}} size={"sm"} variant={"default"} title={props.title ? props.title : "Quick Edit"} backdrop={"static"} onClick={() => setShow(true)}>
                <i id={props.id} className="far fa-edit"></i>
            </Button>
            <Modal backdrop={"static"} show={show} onHide={() => setShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{isEditDisabled ? "Προβολή" : "Τροποποίηση"} Είδους Γραμμής</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Dropdown
                        name={"quickEditVat"}
                        label={"Φ.Π.Α. %"}
                        options={getVatOptions()}
                        required={true}
                        disabled={isEditDisabled}
                        key={Math.random()}
                        defaultValue={getVatOptions().find((el) => String(el.value) === String(productData.vatId))}
                        onChange={(e) => handleOnChange(e, "dropdown", "vatPercentage")}
                    />
                    {String(productData.vatId) === "7" && (
                        <React.Fragment>
                            <Dropdown
                                name={"quickEditVatReason"}
                                label={"Λόγος Εξαίρεσης Φ.Π.Α."}
                                className={"mb-2"}
                                options={zeroVatReasonOptions}
                                required={true}
                                disabled={isEditDisabled}
                                key={Math.random()}
                                defaultValue={zeroVatReasonOptions.filter((el) => el.value === productData.vatReason).length > 0 ? zeroVatReasonOptions.filter((el) => el.value === productData.vatReason)[0] : ""}
                                onChange={(e) => handleOnChange(e, "dropdown", "vatReason")}
                            />
                            {String(productData.vatReason) === "16" && (
                                <React.Fragment>
                                    <div className={"mb-2"}>
                                        <label>Ποσό Φ.Π.Α.</label>
                                        <AccountingBox
                                            name={"vat39a"}
                                            fromAccountTable={true}
                                            disabled={isEditDisabled}
                                            defaultValue={productData.vat39a}
                                            key={productData.vat39a}
                                            onBlur={(e) => handleOnChange(e, "acb", "vat39a")}
                                        />
                                    </div>
                                </React.Fragment>
                            )}
                        </React.Fragment>
                    )}
                    <Dropdown
                        name={"quickEditCategory"}
                        label={"Κατηγορία My Data"}
                        options={ecCategory}
                        required={!isEmpty(getBuyObject()?.myDataType)}
                        disabled={isEditDisabled}
                        key={Math.random()}
                        defaultValue={ecCategory.filter((el) => el.value === productData.classificationCategory).length > 0 ? ecCategory.filter((el) => el.value === productData.classificationCategory)[0] : ""}
                        onChange={(e) => handleOnChange(e, "dropdown", "classificationCategory")}
                    />
                    <Dropdown
                        name={"quickEditType"}
                        label={"Τύπος My Data"}
                        options={ecType}
                        required={!isEmpty(getBuyObject()?.myDataType)}
                        disabled={isEditDisabled}
                        key={Math.random()}
                        defaultValue={ecType.filter((el) => el.value === productData.classificationType).length > 0 ? ecType.filter((el) => el.value === productData.classificationType)[0] : ""}
                        onChange={(e) => handleOnChange(e, "dropdown", "classificationType")}
                    />
                    <Dropdown
                        name={"quickEditVatExpenseType"}
                        label={"Τύπος Εξόδων για Φ.Π.Α."}
                        options={vatExpenseType}
                        required={!isEmpty(getBuyObject()?.myDataType)}
                        disabled={isEditDisabled}
                        key={Math.random()}
                        defaultValue={vatExpenseType.filter((el) => el.value === productData.vatExpenseType).length > 0 ? vatExpenseType.filter((el) => el.value === productData.vatExpenseType)[0] : ""}
                        onChange={(e) => handleOnChange(e, "dropdown", "vatExpenseType")}
                    />
                    <BetterCheckBox
                        name={"quickEditAccountingNonDeductibleVAT"}
                        text={"Εκπίπτει τον Φ.Π.Α."}
                        checked={productData?.accountingNonDeductibleVAT !== "active"}
                        onChange={(e) => handleOnChange(e, "checkbox", "accountingNonDeductibleVAT")}
                    />
                    {props.data.vatPercentage !== productData.vatPercentage && (
                        <Alert variant={"info"} className={"mt-1"}>Αλλάζοντας τον Φ.Π.Α. θα μηδενιστούν οι τιμές του είδους στην πώληση.</Alert>
                    )}
                    {productData?.otherTax && (
                        <Alert variant={"info"} className={"mt-1"}>
                            Το είδος περιλαμβάνει λοιπό φόρο: <strong>{getTaxName(productData?.otherTax, "otherTax")}</strong>{" "}
                            με αξία <strong>{getGreekCurrencyFormat(productData?.otherTaxEuro)}</strong>
                        </Alert>
                    )}
                    {productData?.fee && (
                        <Alert variant={"info"} className={"mt-1"}>
                            Το είδος περιλαμβάνει τέλος: <strong>{getTaxName(productData?.fee, "fee")}</strong>{" "}
                            με αξία <strong>{getGreekCurrencyFormat(productData?.feeEuro)}</strong>
                        </Alert>
                    )}
                    {productData?.withHoldTax && (
                        <Alert variant={"info"} className={"mt-1"}>
                            Το είδος περιλαμβάνει παρακρατούμενο φόρο: <strong>{getTaxName(productData?.withHoldTax, "withHoldTax")}</strong>{" "}
                            με αξία <strong>{getGreekCurrencyFormat(productData?.witholdTaxEuro)}</strong>
                        </Alert>
                    )}
                    {productData?.stamp && (
                        <Alert variant={"info"} className={"mt-1"}>
                            Το είδος περιλαμβάνει χαρτόσημο: <strong>{getTaxName(productData?.stamp, "stamp")}</strong>{" "}
                            με αξία <strong>{getGreekCurrencyFormat(productData?.stampEuro)}</strong>
                        </Alert>
                    )}
                    {isEmpty(productData.vatPercentage) && <div style={{"color" : "red"}}>* Πρέπει να συμπληρώσετε Φ.Π.Α. %</div>}
                    {(String(productData.vatId) === "7" && isEmpty(productData.vatReason)) && <div style={{"color" : "red"}}>* Πρέπει να συμπληρώσετε λόγο εξαίρεσης Φ.Π.Α.</div>}
                    {(isEmpty(productData.classificationCategory) && !isEmpty(getBuyObject()?.myDataType))&& <div style={{"color" : "red"}}>* Πρέπει να συμπληρώσετε κατηγορία MyData</div>}
                    {(isEmpty(productData.classificationType) && !isEmpty(getBuyObject()?.myDataType)) && <div style={{"color" : "red"}}>* Πρέπει να συμπληρώσετε τύπο MyData</div>}

                    <FixedAssetBuysAction
                        rowData={props.data}
                        permissionsData={props.permissionsData}
                        setParentShow={setShow}
                    />
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="outline-primary" onClick={() => setShow(false)}>Κλείσιμο</Button>
                    <Button variant="primary" onClick={() => saveClicked()} disabled={invalidProduct()}>Αποθήκευση</Button>
                </Modal.Footer>
            </Modal>
        </React.Fragment>
    )
}

export default BuysProductQuickEdit
